<div class="app-table border rounded w-100 overflow-auto">
  <table cTable hover responsive class="m-0" >
    <ng-content />
  </table>

  <ng-content select="h6" />
</div>
